import React, { Component } from "react";
import { connect } from "react-redux";
import { REST_API, REACT_APP_VERSION } from "../../actions/constants";
// import {withRouter} from 'react-router'
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
// import DashboardTaskModal from './DashboardTaskModal';
import { chartOptions, series, tooltip } from "./chartOptions";
import { Navbar, Nav } from "react-bootstrap";
// import AbortController from 'react-dom'
import axios from "axios";

const encodeQuery = function(param) {

  let data = btoa(param);
  let part1 = data.substr(0, 25);
  let part2 = data.substr(25);

  let reverse = part2 + part1

  let final = btoa(reverse);

  return final    
} 

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			queryLimit: 200, // Controls the number of items fetched per page
			currentSkip: 1, // Controls the current pagination page multiplied by queryLimit
			taskData: [], // The whole data array that hold the 3 different task types
			failedTasks: 0, // array of failed tasks
			failedTasksCount: 0, // Length of failed tasks array
			completedTasks: 0, // array of completed tasks
			completedTasksCount: 0, // Length of completed tasks array
			processedTasks: 0, // array of still processing tasks
			processedTasksCount: 0, // Length of still processing tasks
			options: chartOptions, // Object data for displaying graphical charts
			series: series, // Object data for displaying numerical charts
			tooltip: tooltip, // Object data for displaying chart tooltip
			tasksGroup: [], // Array of object containing the the task type topic
			spinTaskCompleted: 0,
			spinTaskProcessing: 0,
			spinTaskFailed: 0,
			preferences: {},
			version: REACT_APP_VERSION
		};

		this.fetchAllTask = this.fetchAllTask.bind(this);
	}

	AbortController = new window.AbortController();

	filteredFields = `
			filter[fields][description]=true&
			filter[fields][topic]=true&
			filter[fields][name]=true&
			filter[fields][created_at]=true&
			filter[fields][id]=true
		`;
	token = this.props.auth.access_token;

	/**
	 * @mount 		: Will fetch the total task count for each task type
	 * @taskTypes : ['compeleted tasks', 'Still processing tasks', 'failed tasks']
	 *
	 */
	componentDidMount() {
		this.fetchCompletedTasks();
		this.fetchProcessedTasks();
		this.fetchFailedTasks();
		this.getCurrentPreferences();
	}

	getCurrentPreferences = () => {
		axios
			.get("/preferences?access_token=" + this.props.auth.access_token)
			.then((response) => {
				// Only set the export max limit to the local storage
				if (response && response.data && response.data[0]) {
					localStorage.setItem(
						"export_max_limit",
						response.data[0].export_max_limit
					);
				}
			});
	};

	componentWillUnmount() {
		this.AbortController.abort();
	}

	fetchAllTask() {
		this.fetchCompletedTasks();
		this.fetchProcessedTasks();
		this.fetchFailedTasks();
	}

	fetchCompletedTasks = async () => {
		this.setState({
			spinTaskCompleted: 1,
		});

		let json_where = encodeQuery(JSON.stringify({"status":100}))

		await fetch(
			`
						${REST_API}/messagequeues/count?
						where=${json_where}
						&
						access_token=${this.token}
					`,
			{ signal: this.AbortController.signal }
		)

		/*await fetch(
			`
						${REST_API}/messagequeues/count?
						where[status]=100
						&
						access_token=${this.token}
					`,
			{ signal: this.AbortController.signal }
		)*/
			.then((res) => res.json())
			.then((data) => {
				this.setState({
					series: [
						{
							data: [
								data.count,
								this.state.processedTasksCount,
								this.state.failedTasksCount,
							],
						},
					],
					completedTasksCount: data.count,
				});

				setTimeout(() => {
					this.setState({
						spinTaskCompleted: 0,
					});

					console.log("Triggered Completed Task Event");
				}, 300);
			}); //End of completedTasks
	};

	fetchProcessedTasks = async () => {
		this.setState({
			spinTaskProcessing: 1,
		});

		await fetch(
			`
						${REST_API}/analytics/messagequeues?category=count/tasks&status=processing
						&
						access_token=${this.token}
					`,
			{ signal: this.AbortController.signal }
		)
			.then((res) => res.json())
			.then((data) => {
				let dCount = 0;

				dCount =
					data.messagequeues &&
					data.messagequeues[0] &&
					data.messagequeues[0]["count"]
						? data.messagequeues[0]["count"]
						: 0;

				this.setState({
					series: [
						{
							data: [
								this.state.completedTasksCount,
								dCount,
								this.state.failedTasksCount,
							],
						},
					],
					processedTasksCount: dCount,
				});

				setTimeout(() => {
					this.setState({
						spinTaskProcessing: 0,
					});

					console.log("Triggered Processed Task Event");
				}, 300);
			}); //End of processedTasks
	};

	fetchFailedTasks = async () => {
		this.setState({
			spinTaskFailed: 1,
		});

		let json_where = encodeQuery(JSON.stringify({"status":-1}))

		await fetch(
			`
						${REST_API}/messagequeues/count?
						where=${json_where}
						&
						access_token=${this.token}
					`,
			{ signal: this.AbortController.signal }
		)
		/*await fetch(
			`
						${REST_API}/messagequeues/count?
						where[status]=-1
						&
						access_token=${this.token}
					`,
			{ signal: this.AbortController.signal }
		)*/
			.then((res) => res.json())
			.then((data) => {
				this.setState({
					series: [
						{
							data: [
								this.state.completedTasksCount,
								this.state.processedTasksCount,
								data.count,
							],
						},
					],
					failedTasksCount: data.count,
				});

				setTimeout(() => {
					this.setState({
						spinTaskFailed: 0,
					});

					console.log("Triggered Failed Task Event");
				}, 300);
			}); //End of failedTasks
	};

	/**
	 * @function 		: Only fetch 5 properties fomr the messagequeue endpoint and then update the component state
	 * @params 			: ['id', 'name', 'description', 'topic', 'create_at']
	 * @taskTypes 	: ['compeleted tasks', 'Still processing tasks', 'failed tasks']
	 */
	fetchTaskData = async () => {
		const token = this.props.auth.access_token;

		let queryLimit = this.state.queryLimit;

		await //	Fetch "completed tasks"
		// ${REST_API}/messagequeues?
		// access_token=${token}
		fetch(`
						${REST_API}/messagequeues/count?
						filter[where][status]=100
						&
						filter[limit]=${queryLimit}
						&
						${this.filteredFields}
						&
						access_token=${token}
					`)
			.then((res) => res.json())
			.then((data) => {
				this.setState({
					completedTasks: data,
				});

				//	Fetch "still processing tasks"
				fetch(`
							${REST_API}/messagequeues?
							filter[where][status][lt]=100
							&
							filter[status][gt]=-1
							&
							filter[limit]=${queryLimit}
							&
							${this.filteredFields}
							&
							access_token=${token}
						`)
					.then((res) => res.json())
					.then((data) => {
						this.setState({
							processedTasks: data,
						});
						// const another1 =  data.map(item => item.topic )

						//	Fetch "failed tasks"
						fetch(`
									${REST_API}/messagequeues?
									filter[where][status]=-1
									&
									filter[limit]=${queryLimit}
									&
									${this.filteredFields}
									&
									access_token=${token}
								`)
							.then((res) => res.json())
							.then((data) => {
								this.setState({
									failedTasks: data,
								});
							}); // End of Failed tasks
					}); //End of processed tasks
			}); // End of completed tasks
	};

	// //	Handle the next page button
	// handleFetchNextData = async e => {
	// 	await
	// 	this.setState({
	// 		currentSkip: ++this.state.currentSkip
	// 	})

	// 	this.identifyTaskType(e)
	// }

	// // Handle the previous page button
	// handleFetchPrevData = async e => {
	// 	await
	// 	this.setState({
	// 		currentSkip: --this.state.currentSkip
	// 	})

	// 	this.identifyTaskType(e)
	// }

	// /**
	//  * @function : Will dynamically populate the appropriate data on each modal rendered in the DOM
	//  *
	//  */
	// identifyTaskType = (e) => {
	// 	let skipValue = this.state.currentSkip === 1 ? 0 : this.state.queryLimit * (this.state.currentSkip - 1)

	// 	let taskType = ''
	// 	let taskTypeQuery = ''

	// 	switch(e){
	// 		case "Completed":
	// 			taskType = 'completedTasks'
	// 			taskTypeQuery = '=100'
	// 			this.fetchNewdata(taskType, taskTypeQuery, skipValue)
	// 			break
	// 		case "Processing":
	// 			taskType = 'processedTasks'
	// 			taskTypeQuery = '[lt]=100&filter[where][status][gt]=-1'
	// 			this.fetchNewdata(taskType, taskTypeQuery, skipValue)
	// 			break
	// 		case "Failed":
	// 			taskType = 'failedTasks'
	// 			taskTypeQuery = '=-1'
	// 			this.fetchNewdata(taskType, taskTypeQuery, skipValue)
	// 			break

	// 		default:
	// 			break
	// 	}
	// }

	// /**
	//  * @function : Fetch new page data based on querylimit
	//  * Only fetch 5 properties from the endpoint
	//  *
	//  * @param {int} 		id 						: task id
	//  * @param {string} 	name 					: task name
	//  * @param {string} 	description 	: task description
	//  * @param {string} 	topic 				: task topic
	//  * @param {date} 		created_at 		: task created at date
	//  */
	// fetchNewdata = async (taskType, taskTypeQuery, skipValue) => {

	// 	const token = this.props.auth.access_token
	// 	const queryLimit = this.state.queryLimit

	// 	await fetch(`
	// 			${REST_API}/messagequeues?
	// 			filter[where][status]${taskTypeQuery}
	// 			&
	// 			filter[limit]=${queryLimit}
	// 			&
	// 			${this.filteredFields}
	// 			&
	// 			filter[skip]=${skipValue}
	// 			&
	// 			access_token=${token}
	// 		`)
	// 		.then(res => res.json())
	// 		.then(data => {
	// 			this.setState({
	// 				[taskType]: data
	// 			})

	// 		})

	// }

	render() {
		return (
			<div id="task-dashboard">
				<div className="row" style={{ margin: "unset" }}>
					<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
						<div className="card-deck">
							<div className="card text-info bg-light">
								{/* <div className="card-body text-center" data-toggle="modal" data-target="#completedTasks"> */}
								<Link to="/tasks/completed">
									<div className="card-body text-center">
										<p className="card-title title-size">
											<i className="fa fa-check"></i>
										</p>
										<h6 className="card-title title-size">
											Completed
										</h6>
										<h6 className="card-title title-size">
											Tasks
										</h6>
									</div>
								</Link>
								<div className="card-footer text-center">
									<div className="row">
										<div className="col-md-6 text-md-left">
											<Link to="/tasks/completed">
												<span className="card-count">
													{
														this.state
															.completedTasksCount
													}
												</span>
											</Link>
										</div>
										<div className="col-md-6 text-md-right">
											<button
												type="button"
												className="btn float-right"
												onClick={this.fetchAllTask}
											>
												<i
													className={`fas fa-sync-alt ${
														this.state
															.spinTaskCompleted
															? " fa-spin"
															: ""
													}`}
												></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card text-info bg-light">
								<Link to="/tasks/processing">
									{/* <div className="card-body text-center" data-toggle="modal" data-target="#processedTasks"> */}
									<div className="card-body text-center">
										<p className="card-title title-size">
											<i
												className={`fa fa-cog fa-lg ${
													this.state
														.processedTasksCount
														? " fa-spin"
														: ""
												}`}
											></i>
										</p>
										<h6 className="card-title title-size">
											Processing
										</h6>
										<h6 className="card-title title-size">
											Tasks
										</h6>
									</div>
								</Link>

								<div className="card-footer text-center">
									<div className="row">
										<div className="col-md-6 text-md-left">
											<Link to="/tasks/processing">
												<span className="card-count">
													{
														this.state
															.processedTasksCount
													}
												</span>
											</Link>
										</div>
										<div className="col-md-6 text-md-right">
											<button
												type="button"
												className="btn float-right"
												onClick={this.fetchAllTask}
											>
												<i
													className={`fas fa-sync-alt ${
														this.state
															.spinTaskProcessing
															? " fa-spin"
															: ""
													}`}
												></i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="card text-info bg-light">
								<Link to="/tasks/failed">
									{/* <div className="card-body text-center" data-toggle="modal" data-target="#failedTasks"> */}
									<div className="card-body text-center">
										<p className="card-title title-size">
											<i className="fas fa-exclamation-triangle"></i>
										</p>
										<b>
											<h6 className="card-title title-size">
												Failed
											</h6>
										</b>
										<h6 className="card-title title-size">
											Tasks
										</h6>
									</div>
								</Link>
								<div className="card-footer text-center">
									<div className="row">
										<div className="col-md-6 text-md-left">
											<Link to="/tasks/failed">
												<span className="card-count">
													{
														this.state
															.failedTasksCount
													}
												</span>
											</Link>
										</div>
										<div className="col-md-6 text-md-right">
											<button
												type="button"
												className="btn float-right"
												onClick={this.fetchAllTask}
											>
												<i
													className={`fas fa-sync-alt ${
														this.state
															.spinTaskFailed
															? " fa-spin"
															: ""
													}`}
												></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
						<div className="card text-center">
							<Link to="/message-queues">
								<h4 className="text-info">
									Tasks Overview Graph
								</h4>
							</Link>
							<div className="container">
								<Chart
									options={this.state.options}
									series={this.state.series}
									type="bar"
									width="100%"
									height="250"
								/>
							</div>
						</div>
					</div>
				</div>

				{/* <DashboardTaskModal 
					modalId={'completedTasks'}
					modalTitle={'Completed'}
					modalData={this.state.completedTasks}
					taskCount={this.state.completedTasksCount}
					queryLimit={this.state.queryLimit}
					pageCount={this.state.completedTasksCount}
					handleFetchPrevData={this.handleFetchPrevData}
					handleFetchNextData={this.handleFetchNextData}
					currentSkip={this.state.currentSkip}
				/>
				
				<DashboardTaskModal 
					modalId={'processedTasks'}
					modalTitle={'Processing'}
					modalData={this.state.processedTasks}
					taskCount={this.state.processedTasksCount}
					queryLimit={this.state.queryLimit}
					pageCount={this.state.processedTasksCount}
					handleFetchPrevData={this.handleFetchPrevData}
					handleFetchNextData={this.handleFetchNextData}
					currentSkip={this.state.currentSkip}
				/>
				<DashboardTaskModal 
					modalId={'failedTasks'}
					modalTitle={'Failed'}
					modalData={this.state.failedTasks}
					taskCount={this.state.failedTasksCount}
					queryLimit={this.state.queryLimit}
					pageCount={this.state.failedTasksCount}
					handleFetchPrevData={this.handleFetchPrevData}
					handleFetchNextData={this.handleFetchNextData}
					currentSkip={this.state.currentSkip}
				/> */}
				<div className="fixed-bottom justify-content-center">  
                    <Navbar color="dark" className="">
                        <Nav className="mx-auto">
							<span style={{fontSize: '0.875rem'}}>Excelym.IO Release version {this.state.version} &copy; 2023</span>
                        </Nav>
                    </Navbar>
                </div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
	};
};

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js